import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const WhatsAppButton = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const phoneNumber = '919111841033';
  const message = encodeURIComponent('Assalamu Alaikum! I would like to place an order from Fazila Creations.');

  const handleClick = () => {
    if (isExpanded) {
      window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
    } else {
      setIsExpanded(true);
    }
  };

  return (
    <div className="fixed bottom-6 right-4 z-50">
      <AnimatePresence mode="wait">
        {isExpanded ? (
          <motion.div
            key="expanded"
            initial={{ scale: 0.8, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.8, opacity: 0, y: 20 }}
            className="bg-card border border-border rounded-2xl p-4 shadow-xl min-w-[260px]"
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-2">
                <div className="h-10 w-10 rounded-full bg-[#25D366] flex items-center justify-center">
                  <MessageCircle className="h-5 w-5 text-primary-dark" />
                </div>
                <div>
                  <p className="font-display text-sm text-silver-light">Fazila Creations</p>
                  <p className="text-xs text-muted-foreground">Usually replies instantly</p>
                </div>
              </div>
              <button
                onClick={() => setIsExpanded(false)}
                className="text-muted-foreground hover:text-silver transition-colors"
                aria-label="Close"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
            
            <div className="bg-muted/50 rounded-xl p-3 mb-3">
              <p className="text-sm text-foreground font-body">
                Assalamu Alaikum! 🌙
              </p>
              <p className="text-sm text-muted-foreground font-body mt-1">
                How can we help you today? Feel free to ask about our products or customizations.
              </p>
            </div>

            <Button
              variant="whatsapp"
              className="w-full"
              onClick={handleClick}
            >
              <MessageCircle className="h-4 w-4" />
              Start Chat
            </Button>
          </motion.div>
        ) : (
          <motion.button
            key="collapsed"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleClick}
            className="group flex items-center gap-2 bg-[#25D366] hover:bg-[#22c55e] text-primary-dark font-medium px-4 py-3 rounded-full shadow-lg transition-all duration-300"
          >
            <MessageCircle className="h-5 w-5" />
            <span className="text-sm font-sans">Order on WhatsApp</span>
          </motion.button>
        )}
      </AnimatePresence>
    </div>
  );
};

export default WhatsAppButton;
